export const OTHER_SEVERITIES_COLUMN_LABEL = 'Other severities';
